define("shared/helpers/is-last", ["exports", "@ember/component/helper", "@ember/debug"], function (_exports, _helper, _debug) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _exports.isLast = isLast;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/helper",0,"@ember/debug"eaimeta@70e063a35619d71f
  /**
   * @module Helpers
   */
  /**
   * @class LaterHelpers
   * @extends Helpers
   */
  /**
   * Checking if the index is the last element
   *
   * @method is-last
   * @param {Number} index Index of the intended element
   * @param {Number} array The array to check the last element
   *
   * @return {Boolean} is last element
   */
  function isLast(_ref /*, hash*/) {
    let [index, array] = _ref;
    (false && !(typeof index === 'number') && (0, _debug.assert)('Must pass a number for index', typeof index === 'number'));
    (false && !(Array.isArray(array)) && (0, _debug.assert)('Must pass an Array for array', Array.isArray(array)));
    return index === array.length - 1;
  }
  var _default = _exports.default = _helper.default.helper(isLast);
});